@layer ch-grid {
  ch-grid-action-refresh[disabled] {
    pointer-events: none;
  }
}